import {AxiosError} from 'axios';
import {POST_NOTIFICATION_TEMPLATE_LISTING_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {Pageable, PageDataSort} from '../group-special-consideration/usePostGroupSCListing';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NotificationTemplateListingRequest {
  notificationType: string;
  apiPathParam: ApiPathParam;
}

export interface NotificationTemplateListingResponseContentObject {
  uuid: string;
  title: string;
  dateUpdated: string;
  updatedBy: string;
  message: string;
}

export interface NotificationTemplateListingResponse {
  content: NotificationTemplateListingResponseContentObject[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: NotificationTemplateListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNotificationTemplateListing = ({onSuccess, onError}: Input = {}) => {
  const postNotificationTemplateListing = async (
      requestData: NotificationTemplateListingRequest
  ) => {
    const res = await axiosClient.post<NotificationTemplateListingResponse>(
        POST_NOTIFICATION_TEMPLATE_LISTING_URL(requestData.apiPathParam),
        {
          notificationType: requestData.notificationType,
        }
    );
    return res.data;
  };

  return useCustomMutation(postNotificationTemplateListing, {
    onSuccess,
    onError,
  });
};
